export default {
  backend: {
    development: 'http://localhost:8080',
    production: 'https://api.modfin.io'
  },
  defaultPage: '/dashboard',
  loginPage: '/login',
  errorPage: '/error',
  fetchOptions: {credentials: 'include'}
}


// WEBPACK FOOTER //
// ./src/services/config.js